import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import CustomerDetails from "./CustomerDetails";
import DiagnosisAndScheduling from "./DiagnosisAndScheduling";
import IssueDescription from "./IssueDescription";
import ReporterDetails from "./ReporterDetails";
import "./WorkOrderEntry.css";

function WorkOrderEntry({ mode }) {
  return (
    <Container className="work-order-entry-container">
      <Row>
        <Col>
          <IssueDescription mode={mode} />
        </Col>
        <Col>
          <ReporterDetails mode={mode} />
        </Col>
      </Row>
      <Row>
        <Col>
          <DiagnosisAndScheduling mode={mode} />
        </Col>
        <Col>
          <CustomerDetails mode={mode} />
        </Col>
      </Row>
    </Container>
  );
}

WorkOrderEntry.propTypes = {
  mode: PropTypes.oneOf(["create", "update"]).isRequired,
};

export default WorkOrderEntry;
